import { useState, useEffect } from "react"
import Input from "../../Input"
import { toast } from "react-toastify"

const COUNTRY_LIST = [
    {
        name: "ایران",
        code: "IR",
    },
    {
        name: "فنلاند",
        code: "FI",
    },
    {
        name: "ایالات متحده",
        code: "US",
    },
    {
        name: "کانادا",
        code: "CA",
    },
    {
        name: "آلمان",
        code: "DE",
    },
    {
        name: "فرانسه",
        code: "FR",
    },
    {
        name: "بریتانیا",
        code: "GB",
    },
    {
        name: "ایتالیا",
        code: "IT",
    },
    {
        name: "ژاپن",
        code: "JP",
    },
    {
        name: "روسیه",
        code: "RU",
    },
    {
        name: "چین",
        code: "CN",
    },
    {
        name: "هند",
        code: "IN",
    },
    {
        name: "ترکیه",
        code: "TR",
    },
    {
        name: "برزیل",
        code: "BR",
    },
    {
        name: "مکزیک",
        code: "MX",
    },
    {
        name: "استرالیا",
        code: "AU",
    },
    {
        name: "اسپانیا",
        code: "ES",
    },
    {
        name: "هلند",
        code: "NL",
    },
    {
        name: "سوئد",
        code: "SE",
    },
    {
        name: "سوئیس",
        code: "CH",
    },
    {
        name: "کرو جنوبی",
        code: "KR",
    },
    {
        name: "ناشناس",
        code: "UNKNOWN",
    },
]

const AutoCountry = ({ values, serverData }) => {
    const [countrys, setCountrys] = useState(null)
    const [openedCountry, setOpenedCountry] = useState(null)

    useEffect(() => {
        let countrysInput = document.getElementsByName("autoCountry-countryList")[0]
        countrysInput.value = JSON.stringify(countrys)
    }, [countrys])

    useEffect(() => {
        if (values?.countryList) {
            try {
                const r = JSON.parse(values.countryList)
                setCountrys(r)
            } catch (err) {
                setCountrys(values.countryList || [])
            }
        }
        return () => {}
    }, [])

    return (
        <div className="mx-14 h-full">
            <input name="autoCountry-countryList" className="hidden" />
            <h6 className="flex justify-center">کشور اتومات</h6>

            <div className="mt-2">
                <div>
                    <Input
                        type="text"
                        label="ایدی رنک ها برای چشم پوشی"
                        name="autoCountry-ignoreSgList"
                        options={serverData?.sgList}
                        multi={true}
                        autoComplete="off"
                        defaultValue={values?.ignoreSgList}
                        dir="ltr"
                    />
                </div>
                <div className="flex flex-wrap w-full">
                    {countrys?.map((item, index) => (
                        <div key={index}>
                            <span
                                role="button"
                                className="text-blue-400"
                                onClick={() => {
                                    const countryInputsField = document.getElementById("countryInputsField")
                                    const editSection = document.getElementById("editSection2")
                                    const addSection = document.getElementById("addSection2")
                                    const countryNameInput = document.getElementById("countryName")
                                    const sgIDInput = document.getElementById("countrySgID")

                                    countryNameInput.value = item.countryName
                                    sgIDInput.value = item.sgID
                                    countryInputsField.style.display = "flex"
                                    editSection.style.display = "flex"
                                    addSection.style.display = "none"
                                    setOpenedCountry(item.countryName)
                                }}
                            >
                                {item.countryName}
                            </span>{" "}
                            ,{" "}
                        </div>
                    ))}
                    <button
                        id="countryButton"
                        type="button"
                        className="px-2 bg-gray-700 rounded-md"
                        onClick={() => {
                            const countryInputsField = document.getElementById("countryInputsField")
                            const addSection = document.getElementById("addSection2")
                            const editSection = document.getElementById("editSection2")

                            document.getElementsByName("countryName")[0].value = ""
                            document.getElementsByName("countrySgID")[0].value = ""
                            countryInputsField.style.display = "flex"
                            addSection.style.display = "flex"
                            editSection.style.display = "none"
                        }}
                    >
                        Add
                    </button>
                </div>
                <div
                    id="countryInputsField"
                    className="flex justify-between place-items-center gap-5"
                    style={{ display: "none" }}
                >
                    <div className="flex gap-5">
                        <div>
                            <Input
                                type="text"
                                name="countryName"
                                label="اسم کشور"
                                placeholder="countryName"
                                autoComplete="off"
                                dir="ltr"
                            />
                        </div>
                        <div>
                            <Input
                                type="number"
                                name="countrySgID"
                                label="ایدی رنک"
                                placeholder="sgID"
                                autoComplete="off"
                                dir="ltr"
                            />
                        </div>
                    </div>
                    <div className="flex gap-2" id="addSection2" style={{ display: "none" }}>
                        <button
                            type="button"
                            id="addButton"
                            className="styled-button px-2 success justify-item-center mt-5 border-none"
                            onClick={() => {
                                setCountrys((oldV) => {
                                    const countryName = document.getElementsByName("countryName")[0].value
                                    const sgID = document.getElementsByName("countrySgID")[0].value
                                    let newCountrys = oldV ? [...oldV] : []
                                    if (countryName == "" || sgID == "") {
                                        toast.error("لطفا مقادیر خواسته شده را وارد کنید")
                                    } else if (newCountrys.find((r) => r.countryName == countryName)) {
                                        toast.error("کشور با این نام قبلا توسط شما اضافه شده است")
                                    } else if (!COUNTRY_LIST.find((c) => c.code == countryName)) {
                                        toast.error("اسم کشور نامعتبر میباشد")
                                    } else {
                                        newCountrys.push({ countryName, sgID })
                                    }

                                    return newCountrys
                                })

                                document.getElementById("countryInputsField").style.display = "none"
                                document.getElementById("countryButton").style.display = "block"
                            }}
                        >
                            اضافه
                        </button>
                        <button
                            type="button"
                            className="styled-button px-2 bg-gray-500 hover:bg-gray-600 justify-item-center mt-5 border-none"
                            id="cancellButton"
                            onClick={() => {
                                document.getElementById("countryInputsField").style.display = "none"
                            }}
                        >
                            بیخیال
                        </button>
                    </div>
                    <div className="flex gap-2" id="editSection2" style={{ display: "none" }}>
                        <button
                            type="button"
                            id="editButton"
                            className="styled-button px-2 success justify-item-center mt-5 border-none"
                            onClick={() => {
                                setCountrys((oldV) => {
                                    const countryName = document.getElementsByName("countryName")[0].value
                                    const sgID = document.getElementsByName("countrySgID")[0].value

                                    let newCountrys = oldV ? [...oldV] : []
                                    if (countryName == "" || sgID == "") {
                                        toast.error("لطفا مقادیر خواسته شده را وارد کنید")
                                    } else if (!COUNTRY_LIST.find((c) => c.code == countryName)) {
                                        toast.error("اسم کشور نامعتبر است")
                                    } else if (
                                        !newCountrys.find((r) => r.countryName == countryName) ||
                                        countryName == openedCountry
                                    ) {
                                        newCountrys = newCountrys.map((r) => {
                                            if (r.countryName != openedCountry) {
                                                return r
                                            } else {
                                                return { countryName, sgID }
                                            }
                                        })
                                    } else {
                                        toast.error("کشور با این نام قبلا توسط شما اضافه شده است")
                                    }

                                    return newCountrys
                                })

                                document.getElementById("countryInputsField").style.display = "none"
                                document.getElementById("countryButton").style.display = "block"
                            }}
                        >
                            ویرایش
                        </button>
                        <button
                            type="button"
                            id="deleteButton"
                            className="styled-button px-2 danger justify-item-center mt-5 border-none"
                            onClick={() => {
                                setCountrys((oldV) => {
                                    let newCountrys = oldV ? [...oldV] : []
                                    newCountrys.splice(
                                        newCountrys.findIndex((r) => r.countryName == openedCountry),
                                        1,
                                    )

                                    return newCountrys
                                })
                                document.getElementById("countryInputsField").style.display = "none"
                                document.getElementById("countryButton").style.display = "block"
                            }}
                        >
                            حذف
                        </button>
                        <button
                            type="button"
                            className="styled-button px-2 bg-gray-500 hover:bg-gray-600 justify-item-center mt-5 border-none"
                            id="cancellButton"
                            onClick={() => {
                                document.getElementById("countryInputsField").style.display = "none"
                                document.getElementById("countryButton").style.display = "block"
                            }}
                        >
                            بیخیال
                        </button>
                    </div>
                </div>
            </div>

            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>لیست کشور هایی که میتوانید اضافه کنید:</span>
                <br />
                {COUNTRY_LIST.map((item, index) => (
                    <span>
                        <span
                            role="button"
                            onClick={() => {
                                const countryInputsField = document.getElementById("countryInputsField")
                                const addSection = document.getElementById("addSection2")
                                const editSection = document.getElementById("editSection2")
                                const countryNameInput = document.getElementById("countryName")
                                const sgIDInput = document.getElementById("countrySgID")

                                const c = countrys?.find((c) => c.countryName == item.code)
                                countryInputsField.style.display = "flex"
                                if (c) {
                                    countryNameInput.value = c.countryName
                                    sgIDInput.value = c.sgID

                                    editSection.style.display = "flex"
                                    addSection.style.display = "none"

                                    setOpenedCountry(c.countryName)
                                } else {
                                    countryNameInput.value = item.code
                                    sgIDInput.value = ""
                                    editSection.style.display = "none"
                                    addSection.style.display = "flex"
                                }
                            }}
                            key={index}
                            className="text-blue-300"
                        >
                            {item.name}
                        </span>
                        {" ,"}
                    </span>
                ))}
                {/* <br />
                <br />
                <div className="flex justify-between">
                    <span>با دستور روبه رو رنک های تعریف شده را ببینید:</span>
                    <span dir="ltr" className="text-green-300">
                        !rank list{" "}
                    </span>
                </div>
                <div className="flex justify-between">
                    <span>با دستور روبه رو رنک مورد نظر خود را اضافه کنید:</span>
                    <span dir="ltr" className="text-green-300">
                        !rank add rankName{" "}
                    </span>
                </div>
                <div className="flex justify-between">
                    <span>با دستور روبه رو رنک مورد نظر خود را حذف کنید:</span>
                    <span dir="ltr" className="text-green-300">
                        !rank remove rankName{" "}
                    </span>
                </div>{" "} */}
            </div>
        </div>
    )
}

export default AutoCountry
